import intl from "react-intl-universal";
 
/**
 * Generate the name of the accordion based on the scene ID provided in the props.
 *
 * @param {any} props - The props object containing the scene ID.
 * @return {JSX.Element} The name of the accordion to be displayed.
 */
const AccordionChangeLanguage = (props:any) => {
   let accordionname

   if (props.sceneId === 1) {
    accordionname = intl.get('ACC_NAME_ID_1')
   }
   if (props.sceneId === 2) {
    accordionname = intl.get('ACC_NAME_ID_2')
   }
   if (props.sceneId === 3) {
    accordionname = intl.get('ACC_NAME_ID_3')
   }
   if (props.sceneId === 4) {
    accordionname = intl.get('ACC_NAME_ID_4')
   }
   if (props.sceneId === 5) {
    accordionname = intl.get('ACC_NAME_ID_5')
   }

    return (
    <>
      {accordionname}
    </>
    )
    
};

export default AccordionChangeLanguage;